export const NEW_STREAM_PREFIX = 'new-stream';

export const createNewStreamId = (alias: string): string => `${NEW_STREAM_PREFIX}-${alias}`;

export const isNewStreamId = (streamId: string | undefined): boolean =>
  streamId?.startsWith(NEW_STREAM_PREFIX) ?? false;

// All layout dimensions for the AI page to ensure consistency
export const AI_PAGE_LAYOUT = {
  /** Height of the header bar in pixels */
  HEADER_HEIGHT: 70,
  /** Height of the input area in pixels */
  INPUT_HEIGHT: 120,
  /** Maximum width of the input area when centered (not active) */
  INPUT_MAX_WIDTH: 1000,
  /** Maximum content width per screen size (xs → xl) */
  CONTENT_MAX_WIDTH: {
    xs: 800,
    sm: 800,
    md: 800,
    lg: 1200,
    xl: 1600,
  },
  /** Bottom padding for content area to account for input height + spacing */
  CONTENT_PADDING_BOTTOM: 144, // INPUT_HEIGHT (120) + spacing (24)
  /** Animation duration for transitions in milliseconds */
  ANIMATION_DURATION: 300,
} as const;

export const AI_PAGE_TRANSITION = `all ${AI_PAGE_LAYOUT.ANIMATION_DURATION}ms ease-in-out`;

export const AI_ROUTE_PATTERNS = {
  OVERVIEW: '/ai',
} as const;

export const AI_DEFAULTS = {
  /** Default output length for AI responses */
  OUTPUT_LENGTH: 'medium' as const,
  /** Polling interval for stream updates in milliseconds */
  POLL_INTERVAL: 2000,
  /** Maximum number of retries for failed operations */
  MAX_RETRIES: 3,
  /** Safety timeout for polling loops tied to Lambda execution (15 min = Lambda max timeout) */
  POLLING_SAFETY_TIMEOUT_MS: 15 * 60 * 1000,
} as const;

/** Rotating taglines shown on the AI page empty state */
export const AI_TAGLINES = [
  'What can I help you find today?',
  'Ready when you are.',
  'Your logs have answers. Let\u2019s find them.',
  'Ask me anything about your environment.',
  'What are we investigating today?',
  'No question too complex. Ask away.',
  'Let\u2019s make sense of your data.',
  'Here whenever you need me.',
] as const;
